

























































































import { formatMoney, formatNumber, formatPercentage, inputRules } from '@/utils/CommonUtils'
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import InputMoney from '@/components/InputMoney.vue'
import InputNumber from '@/components/InputNumber.vue'
import InputPercentage from '@/components/InputPercentage.vue'
import InputSelect from '@/components/InputSelect.vue'
import InputText from '@/components/InputText.vue'
import InputTextArea from '@/components/InputTextArea.vue'

type Value = string | number | null

@Component({
  components: {
    InputMoney,
    InputNumber,
    InputPercentage,
    InputSelect,
    InputText,
    InputTextArea,
  }
})
export default class BaoCaoCell extends Vue {
  @Prop() readonly initialValue!: Value
  @Prop() readonly format!: 'money' | 'number' | 'percentage' | 'text' | 'long_text' | 'select'
  @Prop() readonly choices!: unknown

  // =========================================================================

  inputRules = inputRules

  value: Value = null
  copiedInitialValue: Value = null

  mounted () {
    this.value = this.initialValue
    this.copiedInitialValue = this.initialValue
  }

  get displayValue () {
    if (typeof this.value === 'string') {
      if (this.value === '') {
        return ''
      }
      else if (this.format === 'money' || this.format === 'number') {
        this.value = parseInt(this.value)
      }
      else if (this.format === 'percentage') {
        this.value = parseFloat(this.value)
      }
      else {
        return this.value
      }
    }
    if (this.format === 'money') {
      return formatMoney(this.value)
    }
    if (this.format === 'number') {
      return formatNumber(this.value, 2)
    }
    if (this.format === 'percentage') {
      return formatPercentage(this.value, 2)
    }
    return ''
  }

  // =========================================================================

  showEditIcon = false

  get iconRight () {
    return this.format === 'text' || this.format === 'long_text' || this.format === 'select'
  }

  get iconLeft () {
    return !this.iconRight
  }

  // =========================================================================

  editing = false

  save () {
    // @ts-expect-error
    const valid = this.$refs.form.validate()
    if (!valid) return
    this.emitSave()
  }

  @Emit('save')
  emitSave () {
    this.editing = false
    this.showEditIcon = false
    this.copiedInitialValue = this.value
    return this.value
  }

  discard () {
    this.editing = false
    this.showEditIcon = false
    this.value = this.copiedInitialValue
  }

  // =========================================================================

  get isEdited () {
    return this.copiedInitialValue !== this.initialValue
  }
}
